export const figure71 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 270,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#a9d18e', '#e2f0d9'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
	    hover: {
			   enabled: true,
			   radius: 5
		   }
    }
}
}
},

exporting: {
enabled: false
},

xAxis: [{
reversed: true,
categories: [ "Afrique du Nord", "Asie du Sud (1)", "Asie de l’Ouest", "Afrique subsaharienne (4)", "Australie et Nouvelle-Zélande", "Océanie", "Amérique du Nord (2)", "Europe (3)", "Asie du Sud-Est (5)", "Amérique latine et Caraïbes (6)", "Asie centrale", "Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)", "Asie de l’Est (7)", "", "Monde" ],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
format: '{value:.1f}',
style: {
	 fontWeight: 'normal',
	 color: '#999999',
	 fontSize: '12px'
 },
},
max: 30.00,
min: 0,
tickInterval: 5.00,
gridLineWidth: 2,
title: {
	text: '',
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [      
{
name: '2015',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
	fontWeight: 'normal',
	textOutline: false,
	color: '#999999',
	fontSize: '10px'
}
},
data: [3.26, 4.49, 4.68, 6.7, 7.2, 8.06, 9.71, 11.05, 13.52, 15.67, 20.22, 22.9, 24.78, null, 11.27],
},
{
name: '2019',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
	fontWeight: 'normal',
	textOutline: false,
	color: '#999999',
	fontSize: '10px'
}
},
data: [4.57, 10.41, 11.73, 14.63, 8.03, 8.65, 11.72, 12.84, 17.64, 21.89, 20.32, 19.6, 26.32, null, 15.54],
},
]
}